import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import { loadJson } from '../utils/loadJson'; // Importa la función de carga de JSON

const Navbar = () => {
    const { language, setLanguage } = useContext(LanguageContext);
    // const { language, setLanguage } = useContext(LanguageContext);
    const [translations, setTranslations] = useState({});


    useEffect(() => {
        
        const fetchTranslations = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/translations.json`);
            setTranslations(data);
        };

        

        fetchTranslations();
        
    }, []);

    const t = translations[language] || {};

    return (
        <div id="header">

            <nav>
                <ul>

                    <li className="fork">
                        <Link to="/" className="text-white">{t.nav?.home}</Link>
                    </li>
                    <li className="fork">
                        <Link to="/projects" className="text-white">{t.nav?.projects}</Link>
                    </li>
                    <li className="fork">
                        <Link to="/languages" className="text-white">{t.nav?.languages}</Link>
                    </li>
                    <li className="fork">

                        <Link to="/contact" className="text-white">{t.nav?.contact}</Link>
                    </li>
                    <li className="fork">

                    </li>
                    <li className="fork">
                        {/* <div classNanme="langSelect"> */}
                            <select value={language} onChange={(e) => setLanguage(e.target.value)} className="text-white" >
                                <option value="es">Español</option>
                                <option value="en">English</option>
                            </select>

                        {/* </div> */}
                    </li>
                   

                </ul>
            </nav>
            <div >
                            <img src="img/MiLogo.png" alt="Logo" />
                        </div>

        </div>




    );
};

export default Navbar;